var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivateImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M29.3333 0.384918H10.6667C3.85778 0.384918 0 4.39107 0 11.4618V30.8465C0 37.8988 3.84 41.9234 10.6667 41.9234H29.3333C36.1422 41.9234 40 37.8988 40 30.8465V11.4618C40 4.39107 36.1422 0.384918 29.3333 0.384918Z",
    fill: "#130F26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0013 14.0291C16.0663 14.0291 12.8763 17.2191 12.8763 21.1541C12.8763 25.0891 16.0663 28.2791 20.0013 28.2791C23.9363 28.2791 27.1263 25.0891 27.1263 21.1541C27.1263 17.2191 23.9363 14.0291 20.0013 14.0291ZM11.293 21.1541C11.293 16.3446 15.1918 12.4458 20.0013 12.4458C24.8108 12.4458 28.7096 16.3446 28.7096 21.1541C28.7096 25.9636 24.8108 29.8624 20.0013 29.8624C15.1918 29.8624 11.293 25.9636 11.293 21.1541Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9987 15.6125C20.4359 15.6125 20.7904 15.9669 20.7904 16.4041V20.6648L23.5194 22.0294C23.9105 22.2249 24.069 22.7004 23.8735 23.0915C23.6779 23.4826 23.2024 23.6411 22.8113 23.4455L19.6447 21.8622C19.3764 21.7281 19.207 21.454 19.207 21.1541V16.4041C19.207 15.9669 19.5615 15.6125 19.9987 15.6125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivateImg);
export default __webpack_public_path__ + "static/media/ActivateImg.52d1b35d9b4b9ed6728d7650d868da08.svg";
export { ForwardRef as ReactComponent };